import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { global } from '@angular/core/src/util';
import { GlobalProvider } from '../global/global';
/*
/*
  Generated class for the MenuProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MenuProvider {
  private api: string;
  constructor(public http: Http,public global:GlobalProvider) {
    console.log('Hello MenuProvider Provider');
    this.api = this.global.api;
  }
 // Devuelve todos el programa de un congreso
 public all(clavecongreso): Observable<any> {
 
  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });
  let parametros ={
    "token": this.global.token,
    "clavecongreso": clavecongreso
  };
  
  
 
  return this.http.post(this.api+"menu/listaarbol.php", parametros, options).map(
    (response) => {
     
      return response.json();
      
    }
  ).catch(this.handleError);
}
public allfiltro(clavecongreso,clave): Observable<any> {
 
  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });
  let parametros ={
    "token": this.global.token,
    "clavecongreso": clavecongreso,
    "clavepadre":clave 
  };
  
  
 
  return this.http.post(this.api+"menu/listafiltro.php", parametros, options).map(
    (response) => {
     
      return response.json();
      
    }
  ).catch(this.handleError);
}
public allpadre(clavecongreso): Observable<any> {
 
  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });
  let parametros ={
    "token": this.global.token,
    "clavecongreso": clavecongreso 
  };
  
  
 
  return this.http.post(this.api+"menu/listapadre.php", parametros, options).map(
    (response) => {
     
      return response.json();
      
    }
  ).catch(this.handleError);
}
public delete(nmenu): Observable<any> {
 
  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

  let parametros ={
    "token":this.global.token,
    "tabla": "menu",
    "clave": nmenu,
  };

  return this.http.post(this.api+"apigen/delete.php", parametros, options).map(
    (response) => {
      return response.json(); 
    }
  ).catch(this.handleError);
}

// Inserta un congreso nuevo
public insert(congreso,menu): Observable<any> {

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });
  menu.clavecongreso = congreso.clave;

  let parametros ={
    "token":this.global.token,
    "tabla": "menu",
    "clavecongreso":congreso.clave,
    "parametros": menu
  };
  
  
  return this.http.post(this.api+"apigen/insert.php", parametros, options).map(
    (response) => {
      return response.json(); 
    }
  ).catch(this.handleError);
}

// Inserta un congreso nuevo
public update(congreso,menu): Observable<any> {

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

  let parametros ={
    "token":this.global.token,
    "tabla": "menu",
    "clave": menu.clave,
    "clavecongreso":congreso.clave,
    "parametros": menu
  };
 console.log(parametros);
  return this.http.post(this.api+"apigen/update.php", parametros, options).map(
    (response) => {
      var respuesta = response.json();
      
       return respuesta[0];
    }
  ).catch(this.handleError);
}


private handleError (error: Response | any) {
  // In a real world app, you might use a remote logging infrastructure
  let errMsg: string;
  if (error instanceof Response) {
    const body = error.json() || '';
    const err = body.error || JSON.stringify(body);
    errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
  } else {
    errMsg = error.message ? error.message : error.toString();
  }
  console.error(errMsg);
  return Observable.throw(errMsg);
}
public ordena(congreso,menu): Observable<any> {

  let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = new RequestOptions({ headers: headers });

  let parametros ={
    "token":this.global.token,
    "tabla": "menu",
    "parametros": menu
  };
 
  return this.http.post(this.api+"apigen/orden.php", parametros, options).map(
    (response) => {
     
      return response.json(); 
    }
  ).catch(this.handleError);
}
}



// WEBPACK FOOTER //
// ./src/providers/menu/menu.ts